import { BrandUtil } from 'dw-us-ui';

const brand = BrandUtil.getBrand();
const brandTag = BrandUtil.content(brand).tag.toLowerCase();

export const getEnvironment = () => {
	const url = window.location.href;

	// Fox on UAT gets ST since Fox/RAD has is currently only using ST this is temproary
	if (brandTag === 'fox' && url.includes('.uat')) {
		return 'st'; // <-- only fox in UAT
	}

	// everyone else (or Fox in non-UAT) uses the normal rules
	if (url.includes('.uat')) return 'uat';
	if (url.includes('.st')) return 'st';
	if (url.includes('www') || url.includes('preview')) return 'master';
	return 'master';
};
